<template>
  <div class="hello">
    <h1>K3 Survey Tool</h1>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat, omnis. Quod incidunt cumque dolorum maxime quam. Debitis voluptatum, sunt quisquam velit, a ab repellat pariatur iusto eveniet est molestiae ullam?</p>
    <br>
    <div>
      <img style="max-width:150px;max-height:150px;" src="http://www.stickpng.com/assets/images/58429049a6515b1e0ad75ab7.png" alt="">
      <div class="headline">Employee Surveey</div>
      <div>Q3 2018</div>
      <router-link :to="{ name: 'survey', params: { link: 'vodafone' }}">Start Survey Now</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Demo Survey App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue